import { ScheduledBreak } from '@traba/types'

/** Default break length in minutes when adding a new break */
export const DEFAULT_BREAK_LENGTH = 30

/** Break duration options for dropdowns (5 to 60 minutes in 5-minute increments) */
export const BREAK_OPTIONS = Array.from({ length: 12 }, (_, i) => {
  const len = (i + 1) * 5
  return { value: `${len}`, label: `${len} min` }
})

/**
 * @deprecated Use BREAK_OPTIONS constant instead
 */
export function getBreakOptions() {
  return BREAK_OPTIONS
}

/**
 * Increases the count for a break of the given length, or adds a new break entry if none exists.
 */
export function increaseBreakCount(
  breaks: ScheduledBreak[],
  breakLength: number,
): ScheduledBreak[] {
  const idx = breaks.findIndex((b) => b.breakLength === breakLength)
  if (idx === -1) {
    return [...breaks, { breakLength, count: 1 }]
  }
  return [
    ...breaks.slice(0, idx),
    { breakLength, count: breaks[idx].count + 1 },
    ...breaks.slice(idx + 1),
  ]
}

/**
 * Decreases the count for a break of the given length.
 * If count reaches 0, removes the break entry entirely.
 */
export function decreaseBreakCount(
  breaks: ScheduledBreak[],
  breakLength: number,
): ScheduledBreak[] {
  const idx = breaks.findIndex((b) => b.breakLength === breakLength)
  if (idx === -1) {
    return breaks
  }
  if (breaks[idx].count === 1) {
    return [...breaks.slice(0, idx), ...breaks.slice(idx + 1)]
  }
  return [
    ...breaks.slice(0, idx),
    { breakLength, count: breaks[idx].count - 1 },
    ...breaks.slice(idx + 1),
  ]
}

/**
 * Expands scheduled breaks into a sorted array of individual break lengths.
 * e.g., [{breakLength: 30, count: 2}, {breakLength: 15, count: 1}] => [15, 30, 30]
 */
export function expandScheduledBreaks(breaks: ScheduledBreak[]): number[] {
  return breaks
    .flatMap(({ breakLength, count }) => Array(count).fill(breakLength))
    .sort((a, b) => a - b)
}
